module.exports = __webpack_public_path__ + "static/media/orange.8e1a9dfb.jpg";